import React from 'react';

import type { SortConfig } from '../../layouts/front/sectionHelpers.js';

import { sectionMappings } from '../../layouts/front/sectionHelpers.js';

interface SorterProps {
  handleSort: (config: SortConfig) => void;
  activeSort: SortConfig | null;
  section?: string;
}

export const Sorter: React.FC<SorterProps> = ({
  handleSort,
  activeSort,
  section,
}) => {
  const mapCriterionName = (criterion: SortConfig) => {
    switch (criterion) {
      case 'relevance':
        return 'Mest relevant';
      case 'date':
        return 'Nyeste først';
      case 'grade':
        return 'Beste rating';
    }
  };

  const sorters = section
    ? sectionMappings[section].sorters
    : (['relevance', 'grade'] as SortConfig[]);

  return (
    <div className={`sorter ${section}`}>
      {sorters.map((criterion) => (
        <button
          key={criterion}
          className={
            activeSort === criterion ||
            (!activeSort && criterion === 'relevance')
              ? 'active'
              : ''
          }
          onClick={() => handleSort(criterion)}
        >
          {mapCriterionName(criterion)}
        </button>
      ))}
    </div>
  );
};
